let routes = [

    // 煤炭
    {
        path: 'coal',
        name: '煤炭',
        component: () => import('@/views/coal/index'),
    },
    {
        path: 'coal/twoPage/enterprise',
        name: '焦煤重点企业资讯二级页',
        component: () => import('@/views/coal/twoPage/enterprise')
    },
    {
        path: 'coal/enterprise',
        name: '焦煤重点企业资讯详情页',
        component: () => import('@/views/coal/detail/enterprise')
    },
    {
        path: 'coal/twoPage/enterprise',
        name: '煤炭重点企业资讯二级页',
        component: () => import('@/views/coal/twoPage/enterprise')
    },
    // {
    //     path: 'coal/enterprise',
    //     name: '煤炭重点企业资讯详情页',
    //     component: () => import('@/views/coal/detail/enterprise')
    // },
    {
        path: 'coal/twoPage/industry',
        name: '焦煤行业动态二级页',
        component: () => import('@/views/coal/twoPage/industry')
    }, {
        path: 'coal/twoPage/standard',
        name: '焦煤技术及标准',
        component: () => import('@/views/coal/twoPage/standard')
    }, {
        path: 'coal/industry',
        name: '焦煤行业动态详情页',
        component: () => import('@/views/coal/detail/industry')
    }, {
        path: 'coal/twoPage/price',
        name: '焦煤价格指数二级页',
        component: () => import('@/views/coal/twoPage/price')
    }, {
        path: 'coal/priceIndex',
        name: '焦煤价格指数详情页',
        component: () => import('@/views/coal/detail/priceIndex.vue')
    }, {
        path: 'coal/twoPage/stock',
        name: '库存二级页',
        component: () => import('@/views/coal/twoPage/stock')
    }, {
        path: 'coal/stock',
        name: '焦煤库存详情页',
        component: () => import('@/views/coal/detail/stock.vue')
    }, {
        path: 'coal/twoPage/report',
        name: '焦煤研究报告二级页',
        component: () => import('@/views/coal/twoPage/report')
    }, {
        path: 'coal/twoPage/yield',
        name: '焦煤产量二级页',
        component: () => import('@/views/coal/twoPage/yield')
    }, {
        path: 'coal/twoPage/rate',
        name: '焦煤开工率二级页',
        component: () => import('@/views/coal/twoPage/rate')
    }, {
        path: 'coal/operatingRate',
        name: '焦煤开工率详情页',
        component: () => import('@/views/coal/detail/operatingRate.vue')
    }, {
        path: 'coal/enterpriseCapacity',
        name: '焦煤企业产能详情页',
        component: () => import('@/views/coal/detail/enterpriseCapacity.vue')
    }, {
        path: 'coal/yield',
        name: '焦煤产量详情页',
        component: () => import('@/views/coal/detail/yield.vue')
    }, {
        path: 'coal/downStream',
        name: '焦煤下游企业详情页',
        component: () => import('@/views/coal/detail/downStream.vue')
    }, {
        path: 'coal/twoPage/downStream',
        name: '焦煤下游企业二级页',
        component: () => import('@/views/coal/twoPage/downStream')
    }, {
        path: 'coal/wash',
        name: '焦煤洗煤厂详情页',
        component: () => import('@/views/coal/detail/wash.vue')
    }, {
        path: 'coal/twoPage/wash',
        name: '焦煤洗煤厂二级页',
        component: () => import('@/views/coal/twoPage/wash')
    }, {
        path: 'coal/twoPage/standard',
        name: '焦煤技术及标准二级页',
        component: () => import('@/views/coal/twoPage/standard')
    },
    {
        path: 'coal/forecast',
        name: '焦煤价格预测详情页',
        component: () => import('@/views/coal/detail/forecast')
    },
    {
        path: 'coal/twoPage/forecast',
        name: '焦煤价格预测二级页',
        component: () => import('@/views/coal/twoPage/forecast')
    },
    {
        path: 'coal/relatedProductsCoal',
        name: '焦煤外部链接详情表',
        component: () => import('@/views/coal/detail/relatedProductsCoal.vue')
    },
    {
        path: 'coal/reportSummary',
        name: '焦煤外部链接汇总表',
        component: () => import('@/views/coal/detail/reportSummary.vue')
    },
    {
        path: 'coal/reportServer',
        name: '进口煤和国内煤价格对比',
        component: () => import('@/views/coal/detail/reportServer.vue')
    },
    {
        path: 'coal/map',
        name: '煤炭地图',
        component: () => import('@/views/coal/detail/map.vue')
    },
    {
        path: 'coal/twoPage/auctioNotice',
        name: '煤炭竞卖预告二级页',
        component: () => import('@/views/coal/twoPage/auctioNotice')
    },
    {
        path: 'coal/auctioNotice',
        name: '煤炭竞卖预告详情页',
        component: () => import('@/views/coal/detail/auctioNotice')
    },
]

export default routes;
